import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { AgencySettingsInterface } from "../../Entity/Entities/Settings/Agency/AgencySettingsInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import AgencySettingsFactory from "../../Entity/Factories/AgencySettingsFactory";

export default function* agencyGetList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "agency");
    const settings: AgencySettingsInterface = AgencySettingsFactory.create(res.data.agencySettings[0]);

    yield put({
        type: Constants.GLOBAL_GET_AGENCY_LIST_SUCCESS,
        payload: {
          settings: settings,
        }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
        action.onSuccess.call(this, settings);
    }

  } catch (err) {
    // should signout user if entity could not be loaded
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchGetAgencyList() {
  yield takeEvery(Constants.GLOBAL_GET_AGENCY_LIST, agencyGetList);
}
